import StudentStatusCards from './StudentStatusCards';
import ReenrollmentChart from './ReenrollmentChart';
import NewEnrollmentsChart from './NewEnrollmentsChart';
import WaitingBySegmentChart from './WaitingBySegmentChart';
import WaitingByStatusChart from './WaitingByStatusChart';
import ProgressChart from './ProgressChart';
import SegmentChart from './SegmentChart';
import ReenrollmentPhoneCallChart from './ReenrollmentPhoneCallChart';
import PerformanceMetrics from './PerformanceMetrics'; // Feature flag: SHOW_PERFORMANCE_METRICS
import ActivityFeed from './ActivityFeed';
import QuickActions from './QuickActions';
import { apiInstance } from './../../services/api_service';
import { useEffect, useState } from 'react';
import { LiaUsersSolid, LiaBellSolid } from "react-icons/lia";

// Feature flags
const SHOW_PERFORMANCE_METRICS = false; // Set to true to show performance metrics
const SHOW_QUICK_STATS = false; // Set to true to show quick stats in sidebar
const SHOW_SEGMENT_CHART = false; // Set to true to show segment chart
const SHOW_ACTIVITY_FEED = false; // Set to true to show recent activities

export default function Dashboard() {
  const [loading, setLoading] = useState(true);
  const [reportsMap, setReportsMap] = useState({});

  const convertReportsToMap = (reportsArray) => {
    const mapper = {};
    reportsArray.forEach(report => {
      mapper[report.slug] = report;
    });
    return mapper;
  }
  
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await apiInstance.get('/reports/');
      setReportsMap(convertReportsToMap(response.data));
      setLoading(false);
    } catch (error) {
      console.error('Error fetching reports:', error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center bg-gray-50 min-h-screen">
        <div className="flex items-center space-x-2">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          <span className="text-gray-600 font-medium">Carregando dashboard...</span>
        </div>
      </div>
    );
  }
  
  return (
    <div className="bg-gray-50 min-h-full">
      <div className="max-w-7xl px-4 sm:px-6 lg:px-6 py-6">
        {/* Main Grid Layout */}
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          
          {/* Main Content - Full Width */}
          <div className="lg:col-span-12 space-y-6">
            
            {/* Charts Row */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Reenrollment Chart */}
              {reportsMap?.reenrollment_report && (
                <section className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                  <ReenrollmentChart report={reportsMap?.reenrollment_report} />
                </section>
              )}

              {/* New Enrollments Chart */}
              {reportsMap?.new_enrollments_report && (
                <section className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                  <NewEnrollmentsChart report={reportsMap?.new_enrollments_report} />
                </section>
              )}
            </div>

            {/* Second Row of Charts */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Progress Chart */}
              {reportsMap?.reenrollment_progress && (
                <section className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                  <ProgressChart report={reportsMap?.reenrollment_progress} />
                </section>
              )}

              {/* Waiting by Segment Chart */}
              {reportsMap?.waiting_reenrollment_by_segment && (
                <section className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                  <WaitingBySegmentChart report={reportsMap?.waiting_reenrollment_by_segment} />
                </section>
              )}
            </div>

            {/* Third Row of Charts */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Waiting by Status Chart */}
              {reportsMap?.waiting_reenrollment_by_status && (
                <section className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                  <WaitingByStatusChart report={reportsMap?.waiting_reenrollment_by_status} />
                </section>
              )}

              {/* Reenrollment Phone Call Chart */}
              {reportsMap?.reenrollment_phone_call_by_date && (
                <section className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                  <ReenrollmentPhoneCallChart report={reportsMap?.reenrollment_phone_call_by_date} />
                </section>
              )}
            </div>

            {/* Segment Distribution Chart */}
            {SHOW_SEGMENT_CHART && (
            <section className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <div className="flex items-center gap-2 mb-4">
                <LiaUsersSolid className="text-xl text-green-600" />
                <h3 className="text-lg font-semibold text-gray-900">Distribuição por Segmento</h3>
              </div>
              <SegmentChart />
            </section>
            )}

            {/* Performance Metrics - Feature Flag */}
            {SHOW_PERFORMANCE_METRICS && (
              <section className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                <PerformanceMetrics />
              </section>
            )}
          </div>

          {/* Right Column - Hidden for testing */}
          {/* <div className="lg:col-span-4 space-y-6">
            
            <section className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <QuickActions showQuickStats={SHOW_QUICK_STATS} />
            </section>

            <section className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <div className="flex items-center gap-2 mb-4">
                <LiaBellSolid className="text-xl text-orange-600" />
                <h3 className="text-lg font-semibold text-gray-900">Atividades Recentes</h3>
              </div>
              <ActivityFeed />
            </section>
          </div> */}
        </div>
      </div>
    </div>
  );
}